import { render } from "./BaseCard.vue?vue&type=template&id=6fcc5f22"
import script from "./BaseCard.vue?vue&type=script&lang=js"
export * from "./BaseCard.vue?vue&type=script&lang=js"

import "./BaseCard.vue?vue&type=style&index=0&id=6fcc5f22&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__